import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

const stored = typeof window !== 'undefined' ? localStorage.getItem('cc_lang') : null;
const browser = typeof navigator !== 'undefined' ? (navigator.language || 'en').slice(0, 2) : 'en';
const initial = stored || (LANGUAGES.some((l) => l.code === browser) ? browser : 'en');

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, pt: { translation: pt }, es: { translation: es }, fr: { translation: fr }, de: { translation: de } },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('cc_lang', lng);
  document.documentElement.lang = lng;
});
document.documentElement.lang = initial;

export default i18n;
